import React, { ReactNode } from 'react';
import { cn } from 'shadcn-ui';
import InnerBlock from './InnerBlock';

interface SidebarBlockProps {
  title: string;
  count?: number;
  headerRight?: ReactNode;
  children: ReactNode;
  testId?: string;
  className?: string;
}

export default function SidebarBlock(props: SidebarBlockProps) {
  return (
    <InnerBlock
      title={props.title}
      count={props.count}
      headerSize={2}
      headerRight={props.headerRight}
      testId={props.testId}
      className={cn('[&_h2]:!normal-case', props.className)}
    >
      {props.children}
    </InnerBlock>
  );
}
